export default "/static/explore/86f255d8923c60e93c55378a783a789bb15b2d64/_next/static/images/reminders-hearts-bg-844ed728d9bdf2b82e3ad2c9208c4cb2.jpg";